import { appleSSO, facebookSSO, googleSSO } from "../shared/sso"
import onReCAPTCHASuccess from "shared/verify_recaptcha"
import DetectIframeAndHideSSO from "app/scripts/detect_iframe_and_hide_sso"
import RefreshFormAuthenticityToken from "app/scripts/refresh_form_authenticity_token"
import SetupUnifiedMobileMenu from "shared/scripts/setup_unified_mobile_menu"
import UnifiedProfileDropdown from "shared/components/unified_profile_dropdown"
import ProsumerHome from "app/components/prosumer_home"
import PlanUpgradeButton from "app/components/plan_upgrade_button"
import FeatureToggleManagement from "app/components/feature_toggle_management"
import FeedbackPrompt from "app/components/feedback_prompt/index.tsx"

Object.assign(window.App.Comps, {
  PlanUpgradeButton,
  UnifiedProfileDropdown,
  FeatureToggleManagement,
  FeedbackPrompt,
})

Object.assign(window.App.Scripts, {
  appleSSO,
  googleSSO,
  facebookSSO,
  onReCAPTCHASuccess,
  DetectIframeAndHideSSO,
  RefreshFormAuthenticityToken,
  SetupUnifiedMobileMenu,
  ProsumerHome,
})
